import { BodyM, Heading1 } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'

import { TokenSupport } from '@/design-lib/base-ui/Typography'
import { paddingBottom } from '@/shared-styles/styles.css'

const SuccessIBuyerOrOda: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <Heading1 as="h2" className={paddingBottom['s-m']}>
        {t('contact-form:casavo.success.title')}
      </Heading1>
      <BodyM className={paddingBottom.l}>
        <TokenSupport>{t('contact-form:casavo.success.subtitle')}</TokenSupport>
      </BodyM>
      <BodyM strong className={paddingBottom.l}>
        <TokenSupport>{t('contact-form:casavo.success.postScriptum')} </TokenSupport>
      </BodyM>
    </>
  )
}
export default SuccessIBuyerOrOda
